import { createModalContext } from 'modules/campaigns/lib/contexts';

export enum ModalType {
  None = 'None',
  AbortCampaignModal = 'AbortCampaignModal',
  ActivateCampaignModal = 'ActivateCampaignModal',
  CancelCampaignModal = 'CancelCampaignModal',
  ChangeCampaignState = 'ChangeCampaignState',
  ConfirmDefaultDisplayPriorityModal = 'ConfirmDefaultDisplayPriorityModal',
  ConfirmDisplayEligibilityCampaign = 'ConfirmScheduleEligibilityCampaign',
  ConfirmScheduleCampaign = 'ConfirmScheduleCampaign',
  DeactivateCampaignModal = 'DeactivateCampaignModal',
  DisplayEligibilityCampaign = 'DisplayEligibilityCampaign',
  InAppRecallModal = 'InAppRecallModal',
  ScheduleCampaign = 'ScheduleCampaign',
  ScheduleUnsavedChangesModal = 'ScheduleUnsavedChangesModal',
  SendCampaign = 'SendCampaign',
  SendTimeExperimentCampaignModal = 'SendTimeExperimentCampaignModal',
}

/**
 * TODO: make these types stricter
 */
export type ModalProps = Record<string, any>;

export const { ModalContext, ModalProvider, useModalContext } = createModalContext<
  ModalType,
  ModalProps
>();
